(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-contact-fanbod"] && !Shopify.designMode) return;
  try {
    
        const tabs = document.querySelectorAll('.contact__tab');
        const tabContents = document.querySelectorAll('.contact__content');

        tabs.forEach(tab => {
          tab.addEventListener('click', () => {
            const index = tab.getAttribute('data-tab-index');

            // Remove current class from all tabs and contents
            tabs.forEach(t => t.classList.remove('current'));
            tabContents.forEach(content => content.classList.remove('current'));

            // Add current class to clicked tab and corresponding content
            tab.classList.add('current');
            document.querySelector(`.contact__content[data-tab-content="${index}"]`).classList.add('current');
          });
        });  
      
  } catch(e) { console.error(e); }
})();
})();
